<div fxLayoutAlign="space-around" class="title colors" mat-dialog-title>{{dialogData?.title}}</div>
<div class="msg" mat-dialog-content>
  {{dialogData?.message}}
</div>

<form>
  <mat-form-field appearance="fill">
    <mat-label>Reporting reason</mat-label>
    <mat-select>
      <mat-option *ngFor="let report of reports" [value]="report.value" required>
        {{report.viewValue}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="example-full-width">
    <mat-label>More Information</mat-label>
    <textarea matInput></textarea>
  </mat-form-field>
</form>

<div class="d-flex justify-content-between mt-3">
  <button mat-button color="accent" (click)="matDialogRef.close()">Cancel</button>
  <button mat-button color="primary" (click)="closeWithYes()">Report</button>
</div>
